/**
 * @deprecated call `.count()` directly on iterables
 */
export const getInboxesCount = inboxes => inboxes.count();